import { Subject } from 'rxjs';

const formSubject = new Subject();

export default formSubject;
